module.exports = __webpack_public_path__ + "static/media/icon-scroll-down.8da07813.svg";